import { get, put,Delete,post } from '../axios'

// 后台操作日记-列表
export const operateLogList = params => get(`/web/operate/log/list`,params);


